const FORMATS = {
  ESRI_WKT: "esriwkt",
  GEOSERVER: "geoserver",
  MAPFILE: "mapfile",
  MAPNIK: "mapnik",
  OGC_GML: "gml",
  OGC_XML: "xml",
  OGC_WKT: "wkt",
  POSTGIS: "postgis",
  PROJ_4: "proj4",
  PROJ_4_JS: "js",
  PROJJSON: "PROJJSON",
  WKT_2: "wkt2"
};

module.exports = {
  FORMATS
};
